import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import { UploadFileComponent } from './import/upload/upload-file.component';
import { LoginComponent } from './account/login.component';
import { DataSanityComponent } from './import/data-sanity/data-sanity.component';
import { ReuploadFileComponent } from './import/upload/reupload-file.component';
import { ControlColumnSelectComponent } from './import/column-types/control/control-column-selection.component';
import { OutcomeColumnSelectComponent } from './import/column-types/outcome/outcome-column-selection.component';
import { ExistenceColumnSelectComponent } from './import/column-types/existence/existence-column-selection.component';
import { IdentitiesSelectComponent } from './import/column-types/identities/identities-selection.component';
import { RedundantColumnsSelectComponent } from './import/column-types/redundant/redundant-columns-selection.component';
import { DimensionsColumnsSelectComponent } from './import/column-types/dimensions/dimensions-columns-selection.component';
import { ProjectListComponent } from './projects/project-list.component';
import { PreaggregationStrategySelectComponent } from "./import/preaggregation/preaggregation.component";
import { CardsComponent } from './cards/cards.component';
import { ComplexityMgntComponent } from './import/complexity-mgnt/complexity-mgnt.component';
import { TopValsComponent } from './import/complexity-mgnt/top-vals.component';
import { ReferenceSelectComponent } from './import/column-types/reference/reference.component';
import { ConfidenceComponent } from './cards/confidence.component';
import { BenchmarksComponent } from './benchmarks/benchmarks.component';
import { SeriesComponent } from './import/series/series.component';
import { MainFcstWalkComponent } from './cards/main-fcst-walk.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full'
    },
    {
        path: 'upload', component: UploadFileComponent,
    },
    {
        path: 'reupload', component: ReuploadFileComponent,
    },
    {
        path: 'login', component: LoginComponent
    },
    {
        path: 'data-sanity', component: DataSanityComponent
    },
    {
        path: 'select-column-control', component: ControlColumnSelectComponent
    },
    {
        path: 'select-column-outcome', component: OutcomeColumnSelectComponent
    },
    {
        path: 'select-column-existence', component: ExistenceColumnSelectComponent
    },
    {
        path: 'select-column-reference', component: ReferenceSelectComponent
    },
    {
        path: 'identities', component: IdentitiesSelectComponent
    },
    {
        path: 'select-columns-redundant', component: RedundantColumnsSelectComponent
    },
    {
        path: 'select-columns-dimensions', component: DimensionsColumnsSelectComponent
    },
    {
        path: 'projects', component: ProjectListComponent
    },
    {
        path: 'preaggregation', component: PreaggregationStrategySelectComponent
    },
    {
        path: 'cards', component: CardsComponent
    },
    {
        path: 'confidence', component: ConfidenceComponent
    },
    {
        path: 'complexity-mgnt', component: ComplexityMgntComponent
    },
    {
        path: 'top-vals', component: TopValsComponent
    },
    {
        path: 'benchmarks', component: BenchmarksComponent
    },
    {
        path: 'series', component: SeriesComponent
    },
    {
        path: 'fcst-walk', component: MainFcstWalkComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
